import styled from 'styled-components';
import { mixins } from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';

export const PageHeaderWrapper = styled.div`
  ${mixins.flexSpaceBetween}
  margin-bottom: ${tokens.primitive.space[20]};
`;

export const PageTitle = styled.h1`
  font-family: ${tokens.primitive.typography.fontFamily.base};
  font-size: ${tokens.primitive.typography.fontSize[39]};
  font-weight: ${tokens.primitive.typography.fontWeight.semiBold};
  line-height: ${tokens.primitive.typography.lineHeight.tight};
  color: ${tokens.semantic.color.text.onLight};
  margin: 0;
`;

export const BackButton = styled.button`
  background: ${tokens.semantic.color.button.backgroundSecondary};
  color: ${tokens.semantic.color.button.label};
  border: 1px solid ${tokens.semantic.color.border.backButton};
  border-radius: ${tokens.primitive.radius[21]};
  padding: ${tokens.primitive.space[16]} ${tokens.primitive.space[30]};
  font-family: ${tokens.primitive.typography.fontFamily.base};
  font-size: ${tokens.primitive.typography.fontSize[20]};
  font-weight: ${tokens.primitive.typography.fontWeight.semiBold};
  letter-spacing: ${tokens.primitive.typography.letterSpacing.button};
  line-height: ${tokens.primitive.typography.lineHeight.normal};
  cursor: pointer;
  outline: none;
  box-shadow: ${(props) => (props.$focused ? tokens.primitive.shadow.focusRing : 'none')};

  /* Programmatic .focus() on TV remotes sets :focus, not :focus-visible — match channel row ring. */
  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: ${tokens.primitive.shadow.focusRing};
  }
`;
